module.exports = __webpack_public_path__ + "assets/GoldNu.0fe062fa64da4f395354c8d87dc9449e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldNu.png
// module id = 767
// module chunks = 0